exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TopicsTopEntrance-header[data-v-cc73ec60]{display:flex;align-items:center;justify-content:space-between;background-color:#eee;font-size:16px;padding:0 10px 0 30px;margin:20px 0}.TopicsTopEntrance-main[data-v-cc73ec60]{padding:0 10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-cc73ec60&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/runarea/index.vue
// module id = 630
// module chunks = 0